import {
  collection,
  CollectionReference,
  DocumentData,
  Firestore,
} from "firebase/firestore";

import { AboutYouQuestion } from "./AboutYouQuestion";
import { AboutYourWorkQuestion } from "./AboutYourWorkQuestion";
import { AreaOfChallenge } from "./AreaOfChallenge";
import { Assessment } from "./Assessment";
import { AssessmentProduct } from "./AssessmentProduct";
import { AssessmentSelfStrategy } from "./AssessmentSelfStrategy";
import { AssessmentSolution } from "./AssessmentSolution";
import { AssessmentStats } from "./AssessmentStats";
import { ManagerAssessments } from "./ManagerAssessments";
import { Organisation } from "./Organisation";
import { OrganisationAssessment } from "./OrganisationAssessments";
import { OrganisationPublic } from "./OrganisationPublic";
import { OrganisationQuestion } from "./OrganisationQuestion";
import { OrganisationSolution } from "./OrganisationSolution";
import { Product } from "./Product";
import { ReferralCode } from "./ReferralCode";
import { AssessmentArchivedReport, AssessmentReport } from "./Report";
import { SelfStrategy } from "./SelfStrategy";
import { Solution } from "./Solution";
import { Task } from "./Task";
import { User } from "./User";
import { WorkplaceChallengeQuestion } from "./WorkplaceChallengeQuestion";

export const createCollections = (db: Firestore) => {
  // This is just a helper to add the type to the db responses
  const createCollection = <T = DocumentData>(collectionName: string) => {
    return collection(db, collectionName) as CollectionReference<T>;
  };

  return {
    // All about you and about your job questions
    about_you_questions: createCollection<AboutYouQuestion>(
      "about_you_questions",
    ),

    // All about you and about your job questions
    about_your_work_questions: createCollection<AboutYourWorkQuestion>(
      "about_your_work_questions",
    ),

    // Archived reports
    archived_reports:
      createCollection<AssessmentArchivedReport>("archived_reports"),

    // Each area of challenge for workplace assessments
    area_of_challenges: createCollection<AreaOfChallenge>("area_of_challenges"),

    // Join table between assessment and users
    assessment_managers: createCollection<ManagerAssessments>(
      "assessment_managers",
    ),

    // Join table between assessment and products
    assessment_products: createCollection<AssessmentProduct>(
      "assessment_products",
    ),

    // Join table between assessment and solutions
    assessment_solutions: createCollection<AssessmentSolution>(
      "assessment_solutions",
    ),

    // Self strategies for each assessment
    assessment_self_strategies: createCollection<AssessmentSelfStrategy>(
      "assessment_strategies",
    ),

    // Join table between assessment and solutions
    assessment_stats: createCollection<AssessmentStats>("assessment_stats"),

    // Assessment records where assessment data is stored
    assessments: createCollection<Assessment>("assessments"),

    // All organisations
    organisations: createCollection<Organisation>("organisations"),

    // Public organisation details
    organisation_public: createCollection<OrganisationPublic>(
      "organisation_public",
    ),

    // Organisation assessments
    organisation_assessments: createCollection<OrganisationAssessment>(
      "organisation_assessments",
    ),

    // Organisation questions
    organisation_questions: createCollection<OrganisationQuestion>(
      "organisation_questions",
    ),

    // Organisation solutions
    organisation_solutions: createCollection<OrganisationSolution>(
      "organisation_solutions",
    ),

    // All products
    products: createCollection<Product>("products"),

    // Reports
    reports: createCollection<AssessmentReport>("reports"),

    // Referral codes
    referral_codes: createCollection<ReferralCode>("referral_codes"),

    // Self strategies
    self_strategies: createCollection<SelfStrategy>("self_strategies"),

    // All solutions
    solutions: createCollection<Solution>("solutions"),

    // All tasks
    tasks: createCollection<Task>("tasks"),

    // Core users table
    users: createCollection<User>("users"),

    // All workplace challenge questions
    workplace_challenge_questions: createCollection<WorkplaceChallengeQuestion>(
      "workplace_challenge_questions",
    ),
  };
};
